import { apiClient, type MentionQuery } from "@/shared/api/api-client";
import { instantFromLocalInput } from "@/shared/utils/date-range";
import type { ReportRecorte } from "./report-recorte";

/** O filtro não tem menção nenhuma — a mensagem é a que a pessoa vê. */
export class EmptyRecorteError extends Error {
  constructor() {
    super("O filtro atual não tem menções.");
  }
}

/**
 * A janela da amostra gerada a partir da tela de Menções: a do filtro;
 * sem período lá ("Tudo"), da menção mais antiga à mais recente do
 * filtro — a amostra sempre tem janela, e assim ela leva TODAS as menções
 * do filtro atual (decisão de 2026-10-19, nascida no "Enviar para o
 * Versa"; o "Enviar para o Dashboard" usa a mesma desde 2026-10-27).
 */
export async function resolveReportWindow(
  token: string,
  report: ReportRecorte,
  mentions: MentionQuery,
): Promise<{ start: string; end: string }> {
  const start = instantFromLocalInput(report.from, "start");
  const end = instantFromLocalInput(report.to, "end");
  if (start && end) return { start, end };
  const edge = (order: "published_asc" | "published_desc") =>
    apiClient.listMentions(
      token,
      { ...mentions, page: 1, size: 1, order },
      { withTotal: false },
    );
  const [oldest, newest] = await Promise.all([
    edge("published_asc"),
    edge("published_desc"),
  ]);
  const first = oldest.items[0]?.published_at;
  const last = newest.items[0]?.published_at;
  if (!first || !last) throw new EmptyRecorteError();
  return {
    start: start ?? first,
    // Fecha depois da última: a amostra compara com `<=` e corta os
    // segundos.
    end: end ?? new Date(Date.parse(last) + 60_000).toISOString(),
  };
}
